import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { DefaultTheme } from 'themes/interfaces/default-theme.interfaces';
import clsx from 'clsx';

const makeClasses = makeStyles<DefaultTheme>(theme => ({
  root: {
    backgroundColor: theme.palette.grey[200],
    padding: theme.spacing(2, 3),
    borderRadius: theme.spacing(1),
  },
}));

export const Code: React.FC<React.DetailedHTMLProps<React.HTMLAttributes<HTMLPreElement>, HTMLPreElement>> = (props) => {
  const classes = makeClasses();
  return (
    <pre
      {...props}
      className={clsx(classes.root, props.className)}
    />
  );
};
